module.exports = "/_next/static/media/Image-1.40dcb0b2.png";